/**
 * PermissionSelect
 */

import React from 'react';
import PropTypes from 'prop-types';
import Select from 'components/tags/Select/index.jsx';

function PermissionSelect(props) {
  const { options, disabled, value, onChange, ...rest } = props;
  const handleChange = (ev) => onChange(Number(ev));
  return <Select {...rest} options={options} value={value} onChange={handleChange} disabled={disabled} />;
}

PermissionSelect.propTypes = {
  options: PropTypes.array,
  disabled: PropTypes.bool,
  value: PropTypes.number,
  onChange: PropTypes.func,
};

export default PermissionSelect;
